import React, { FC, useCallback, useRef } from 'react'
import { Link } from 'react-router-dom'
import { GrowlContainer } from '@wmgtech/legato'
import { SBX_MAX_HEADER_HEIGHT, SBX_MIN_HEADER_HEIGHT } from 'shared/utils/header'
import { useScroll } from 'shared/hooks'

import { Logo } from 'components'
import { Search, ZoneMenu } from 'modulesCommon/Header/containers'
import { ZoneNotify } from 'modulesCommon/ZoneNotify'

import { SBXHeaderProps } from './SBXHeader.props'
import { HeroImage } from '../../HeroImage'
import { HeaderMenu } from '../../index'

import useSpaceProjectViews from 'modulesCommon/serviceHooks/useSpaceProjectViews'
import { NotificationDropDown } from 'modulesCommon/Notifications/containers'

import styles from './sbx-header.module.scss'
import { Navbar } from 'components/Navbar/Navbar'

const HEADER_MAX_HEIGHT_VAR = '--sbx-header-max-height'
const HEADER_MIN_HEIGHT_VAR = '--sbx-header-min-height'

export const SBXHeader: FC<SBXHeaderProps> = ({ isLoading, activeArtist }) => {
  useSpaceProjectViews()

  const container = useRef<HTMLHeadingElement | null>()
  const notifyRef = useRef<HTMLDivElement | null>()

  const handleBanner = useCallback(
    (el: HTMLDivElement | null) => {
      notifyRef.current = el
      if (el !== null && container.current) {
        const { height } = el.getBoundingClientRect()
        container.current.parentElement?.style.setProperty(HEADER_MAX_HEIGHT_VAR, SBX_MAX_HEADER_HEIGHT + height + 'px')
        container.current.parentElement?.style.setProperty(HEADER_MIN_HEIGHT_VAR, SBX_MIN_HEADER_HEIGHT + height + 'px')
      } else if (container.current) {
        container.current.parentElement?.style.setProperty(HEADER_MAX_HEIGHT_VAR, SBX_MAX_HEADER_HEIGHT + 'px')
        container.current.parentElement?.style.setProperty(HEADER_MIN_HEIGHT_VAR, SBX_MIN_HEADER_HEIGHT + 'px')
      }
    },
    [],
  )

  const [refProxy] = useScroll((ref, offset) => {

    ref.style.setProperty('--sbx-header-height', SBX_MAX_HEADER_HEIGHT - offset + 'px')
    ref.style.setProperty('--sbx-header-transition', -offset + 'px')
    ref.style.setProperty(
      '--sbx-header-opacity',
      (1 - offset / (SBX_MAX_HEADER_HEIGHT - SBX_MIN_HEADER_HEIGHT)).toString(),
    )

  }, (SBX_MAX_HEADER_HEIGHT - SBX_MIN_HEADER_HEIGHT))

  const proxyContainer = useCallback(
    (el: HTMLHeadingElement | null) => {
      container.current = el
      refProxy(el)
      const notifyRect = notifyRef.current?.getBoundingClientRect()
      el?.parentElement?.style.setProperty(HEADER_MAX_HEIGHT_VAR, SBX_MAX_HEADER_HEIGHT + (notifyRect?.height ?? 0)  + 'px')
      el?.parentElement?.style.setProperty(HEADER_MIN_HEIGHT_VAR, SBX_MIN_HEADER_HEIGHT + (notifyRect?.height ?? 0)  + 'px')
    },
    [refProxy]
  )
  return (
    <header ref={proxyContainer} className={styles.header}>
      <div className={styles.wrapper}>
        <HeroImage activeArtist={activeArtist} />
        <div className={styles.inner}>
          <div className={styles.top}>
            <div className={styles.logo}>
              <Link to="/" className={styles.logoLink}>
                <Logo isLoading={isLoading} />
              </Link>
              <div className={styles.logoTextWrapper}>
                <span className={styles.logoText}>
                  <Link to="/" className={styles.titleLink}>
                    Storybox
                  </Link>
                  <span className={styles.slash}>/</span>
                </span>
                <ZoneMenu />
              </div>
            </div>
            <Search />
            <div className={styles.right}>
              <NotificationDropDown />
              <HeaderMenu/>
            </div>
          </div>
        </div>
        <ZoneNotify handleAppear={handleBanner} />
      </div>
      <div className={styles.navigation}>
        <div className={styles.inner}>
          <Navbar />
        </div>
      </div>N
      <GrowlContainer
        closeOnClick={false}
        closeButton={false}
        hideProgressBar={true}
        newestOnTop={true}
        rtl={false}
        autoClose={5000}
        className={'header-growl-container'}
      />
    </header>
  )
}
